import { render, staticRenderFns } from "./HeaderRowTables.vue?vue&type=template&id=88505d5c&"
import script from "./HeaderRowTables.vue?vue&type=script&lang=js&"
export * from "./HeaderRowTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports